<template>
  <div class="h-100">
    <v-row class="h-100">
      <v-col class="h-50" cols="6">
        <v-row class="h-25">CPU :</v-row>
        <v-row class="h-75">
          <v-col class="text-right mr-3" @contextmenu="onContextmenuChart">
            <span class="text-h4 mr-1">{{ cpu }}</span>
            <span class="text-h7">%</span>
          </v-col>
        </v-row>
      </v-col>
      <v-col class="h-50" cols="6">
        <v-row class="h-25">Memory :</v-row>
        <v-row class="h-75">
          <v-col class="text-right mr-3" @contextmenu="onContextmenuChart">
            <span class="text-h4 mr-1">{{ memory }}</span>
            <span class="text-h7">%</span>
          </v-col>
        </v-row>
      </v-col>
      <v-col class="h-50" cols="6">
        <v-row class="h-25">Disk I/O :</v-row>
        <v-row class="h-75">
          <v-col class="text-right mr-3" @contextmenu="onContextmenuChart">
            <span class="text-h4 mr-1">{{ disk }}</span>
            <span class="text-h7">{{ diskUnit }}</span>
          </v-col>
        </v-row>
      </v-col>
      <v-col class="h-50" cols="6">
        <v-row class="h-25">Network :</v-row>
        <v-row class="h-75">
          <v-col class="text-right mr-3" @contextmenu="onContextmenuChart">
            <span class="text-h4 mr-1">{{ ntwk }}</span>
            <span class="text-h7">{{ ntwkUnit }}</span>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row>
      <contextmenu :options="contextmenuParam"></contextmenu>
    </v-row>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import instanceable from './mixins/instanceable';
import contextmenuable from './mixins/contextmenuable';

export default {
  mixins: [instanceable, contextmenuable],
  data() {
    return {
      cpu: 0,
      memory: 0,
      disk: 0,
      diskUnit: 'KB',
      ntwk: 0,
      ntwkUnit: 'KB',
      contextmenuUrl: '/views/detailview/abap/os',
    };
  },
  computed: {
    ...mapState('common/properties', ['isPcapOs']),
  },
  methods: {
    wsBufferedDataHandler(key, responses, every) {
      const [response] = responses;
      every(key, response.length ? response[response.length - 1].data : []);
    },
    wsDataHandler(key, response) {
      if (key.name == 'rawOsCpu' || key.name == 'pcapOsCpu') this.cpuDataHandler(response);
      else if (key.name == 'rawOsDisk' || key.name == 'pcapOsDisk') this.diskDataHandler(response);
      else if (key.name == 'rawOsMem' || key.name == 'pcapOsMem') this.memoryDataHandler(response);
      else if (key.name == 'rawOsNtwk' || key.name == 'pcapOsNtwk') this.networkDataHandler(response);
    },
    cpuDataHandler(response) {
      // 단건 response는 객체로 온다. 상수로 받을 때 {}를 넣으면 그런 속성 없다는 에러가 난다.2021.12.28.KWShin.
      // const [{ res }] = response;
      const [res] = response;
      this.cpu = Math.ceil(parseFloat(res?.usrTotal ?? '0') + parseFloat(res?.sysTotal ?? '0'));
    },
    diskDataHandler(response) {
      let value = response.reduce((acc, item) => {
        acc += parseInt(item.kbSec);
        return acc;
      }, 0);
      var unit = ['K', 'M', 'G', 'T'];
      var idx = 0;
      while (value >= 1000) {
        value = value / 1000;
        idx++;
      }
      // BEGIN::Modified.by.KWShin.2024.02.14.
      // 소수점 이하 안나오게 조치
      // this.disk = Math.ceil(value * 100) / 100;
      this.disk = Math.ceil(value);
      // FINISH::Modified.by.KWShin.2024.02.14.
      this.diskUnit = unit[idx] + 'B';
    },
    memoryDataHandler(response) {
      // 단건 response는 객체로 온다. 상수로 받을 때 {}를 넣으면 그런 속성 없다는 에러가 난다.2021.12.28.KWShin.
      // const [{ res }] = response;
      const [res] = response;
      if (this.isPcapOs) {
        const memUsed = res?.memUsed ?? '0';
        const memTotal = res?.memTotal ?? '0';
        this.memory = memTotal ? Math.ceil((parseInt(memUsed) / Math.max(1, parseInt(memTotal))) * 100) : 0;
      } else {
        const freeMem = res?.freeMem ?? '0';
        const physMem = res?.physMem ?? '0';
        this.memory = physMem ? Math.ceil((1 - parseInt(freeMem) / Math.max(1, parseInt(physMem))) * 100) : 0;
      }
    },
    networkDataHandler(response) {
      this.ntwk = response.reduce((acc, item) => {
        acc += parseInt(item.packets);
        return acc;
      }, 0);
      this.ntwkUnit = 'P';
    },
  },
  created() {
    this.$websocket.realtime.send({
      requests: [
        {
          key: { name: this.isPcapOs ? 'pcapOsCpu' : 'rawOsCpu', sstmId: this.instance.systemId, instId: this.instance.id },
          fields: ['usrTotal', 'sysTotal'],
          empty: false,
          handler: {
            buffer: this.wsBufferedDataHandler,
            every: this.wsDataHandler,
          },
        },
        {
          key: { name: this.isPcapOs ? 'pcapOsDisk' : 'rawOsDisk', sstmId: this.instance.systemId, instId: this.instance.id },
          fields: this.isPcapOs ? ['devName', 'kbSec'] : ['diskname', 'kbSec'],
          empty: false,
          handler: {
            buffer: this.wsBufferedDataHandler,
            every: this.wsDataHandler,
          },
        },
        {
          key: { name: this.isPcapOs ? 'pcapOsMem' : 'rawOsMem', sstmId: this.instance.systemId, instId: this.instance.id },
          fields: this.isPcapOs ? ['memTotal', 'memUsed'] : ['freeMem', 'physMem'],
          empty: false,
          handler: {
            buffer: this.wsBufferedDataHandler,
            every: this.wsDataHandler,
          },
        },
        {
          key: { name: this.isPcapOs ? 'pcapOsNtwk' : 'rawOsNtwk', sstmId: this.instance.systemId, instId: this.instance.id },
          fields: this.isPcapOs ? ['lanName', 'packets'] : ['lanname', 'packets'],
          empty: false,
          handler: {
            buffer: this.wsBufferedDataHandler,
            every: this.wsDataHandler,
          },
        },
      ],
    });
  },
};
</script>
